 <template>
  <v-menu v-bind="attrs.componentAttrs">
    <slot name="default">
      <v-list class="rounded-lg" :data-locator="attrs.dataLocator" elevation="2" v-if="menu.length !== 0">
        <template v-for="(item, index) in menu" :key="`item${index}`">
            <v-divider v-if="item.title === 'separator'"/>
            <v-list-item v-else
              :key="`item${index}`"
              :class="item.style"
              :data-locator=item.locatorValue
              :disabled="item.loading || item.disabled"
              @click="doItemAction(item)"
            >
            <v-progress-circular v-if="item.loading"
                                 indeterminate
                                 color="primary"
                                 size="24"
                                 class="mr-2"
            />
            <v-list-item-title class="d-flex align-center column-gap-2">
              <template v-if="item.icon">
                <app-icon-ds :icon="item.icon" weight="far" size="xs" color="inherit" />
              </template>
              <span v-html="item.title" />
              <AppFeatureTag v-if="item.hasNewLabel" tag="new" class="ml-4" />
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </slot>

    <template v-slot:activator="attrs">
      <!--
        @slot Activator slot
          @binding {object} attrs attrs to bind
          @binding {object} on events to bind
      -->
      <slot name="activator" v-bind="attrs"></slot>
    </template>
  </v-menu>
</template>

<script>
/**
 * Default Menu
 * @displayName AppMenu
 */
import AppFeatureTag from '@/common/AppFeatureTag.vue'
import { useDataLocator } from '@/common/utils/useDataLocator'

/**
 * A wrapper around the menu component with default styling and custom default behavior
 * All Vuetify props for the menu component are usable.
 * @see https://vuetifyjs.com/en/api/v-menu/#props
 */
export default {
  name: 'AppMenu',
  inheritAttrs: false,
  setup () {
    const { attrs } = useDataLocator()
    return { attrs }
  },
  components: { AppFeatureTag },
  props: {
    /**
     * JSON description of the menu content
     * @example
     * [
     *    {
     *      title: String,
     *      loading: Boolean,
     *      action: function,
     *      disabled: Boolean,
     *      style: String,
     *    }
     * ]
     */
    menu: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    doItemAction (item) {
      item.action(item)
    },
  },
}
</script>